import React, { useEffect } from "react";
import { RouterProvider as AriaRouterProvider } from "react-aria-components";
import { Outlet, useNavigate } from "react-router-dom";
import { useLoadMessages } from "../hooks/use-load-messages";

export function RootRoute() {
  const navigate = useNavigate();
  const hasLoadedMessages = useLoadMessages();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "PROFILE_LANGUAGE_CHANGED") {
        window.location.reload();
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  if (!hasLoadedMessages) return null;

  return (
    <AriaRouterProvider navigate={navigate}>
      <Outlet />
    </AriaRouterProvider>
  );
}
